import { IntlShape } from 'react-intl';
import { messages } from './messages';
import { MediaSchema } from '@fhnw/schemas/media';
import { ButtonSchema } from '@fhnw/schemas/button';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.LayeredContent),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['items'],
    },
  ],
  properties: {
    items: {
      title: intl.formatMessage(messages.Items),
      widgetOptions: {
        frontendOptions: {
          widget: 'custom_object_list_widget',
          widgetProps: {
            schema: {
              title: intl.formatMessage(messages.Item),
              addMessage: intl.formatMessage(messages.AddItem),
              fieldsets: [
                {
                  id: 'default',
                  title: 'Default',
                  fields: ['title', 'description', 'media', 'actions'],
                },
              ],
              properties: {
                title: {
                  title: intl.formatMessage(messages.Title),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'text',
                    },
                  },
                },
                description: {
                  title: intl.formatMessage(messages.Description),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'textarea',
                    },
                  },
                },
                media: {
                  title: intl.formatMessage(messages.Media),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'custom_object_widget',
                      widgetProps: {
                        schema: MediaSchema({ intl: intl }),
                      },
                    },
                  },
                },
                actions: {
                  title: intl.formatMessage(messages.Actions),
                  widgetOptions: {
                    frontendOptions: {
                      widget: 'custom_object_list_widget',
                      widgetProps: {
                        schema: ButtonSchema({ intl: intl }),
                      },
                    },
                  },
                },
              },
              required: ['title'],
            },
          },
        },
      },
    },
  },
  required: [],
});

export default Schema;
